//Modal Add Late Note. The greatest coder alive fixed this absolute dumpster fire on 6/12/25
import { MsalAuthenticationTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { apiConfig, loginRequest } from "../authConfig";

import { regular, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState, useContext } from 'react';
import { GlobalContext } from '../utils/GlobalContext';
import { EDPNContext } from "../pages/edpn/EDPNContext";
import { ECLContext } from "../pages/ecl/ECLContext";
import { addDays, format, isAfter, isBefore, isSameDay, isYesterday, parse, parseISO, set, subDays } from "date-fns";
import { DatePicker } from "@mui/x-date-pickers";
import { TextField } from '@mui/material';
import Select, { SingleValue } from "react-select";

import { Client, TherapistSmallObject, CPTCode, ChoiceOption, VwLateEcldpnreason, EDPNAnswerObject, ECLAnswerObject, APIReturnObject, Status, AbsentReason, EDPNQuestion, EDPNAnswer } from "../utils/Definitions";

interface Props {
    isActive: boolean,
    setActive: any,
    cptCodes: CPTCode[] | null,
    clients: Client[],
}

export const ModalAddLateNote: React.FC<Props> = (props) => {
    const globalContext = useContext(GlobalContext);
    const edpnContext = useContext(EDPNContext);

    const [confirmButtonActive, setConfirmButtonActive] = useState<Boolean>(false);
    const [isSaving, setIsSaving] = useState<Boolean>(false);

    const [clients, setClients] = useState<Client[]>([]);
    const [dateOfService, setDateOfService] = useState<Date | null>(null);

    const [clinicians, setClinicians] = useState<TherapistSmallObject[]>([]);
    const [filteredClinicians, setFilteredClinicians] = useState<TherapistSmallObject[]>([]);
    const [selectedClinician, setSelectedClinician] = useState<ChoiceOption | null>(null);
    const [FilteredCPTCodes, setFilteredCPTCodes] = useState<CPTCode[] | null>();
    const [selectedCptCode, setSelectedCptCode] = useState<CPTCode | null>(null);
    const [selectedLearner, setSelectedLearner] = useState<ChoiceOption | null>(null);
    const [selectedReason, setSelectedReason] = useState<ChoiceOption | null>(null);
    const [selectedLearnerPodId, setSelectedLearnerPodId] = useState<number | null>(null);

    const [isLateAbsentNote, setIsLateAbsentNote] = useState<boolean>(false);
    const [selectedAbsentReason, setSelectedAbsentReason] = useState<AbsentReason | null>();

    const [questions, setQuestions] = useState<EDPNQuestion[]>();
    var tempFlatQuestions: EDPNQuestion[] = [];
    const [flatQuestions, setFlatQuestions] = useState<EDPNQuestion[]>([]);
    const [filteredFlatQuestions, setFilteredFlatQuestions] = useState<EDPNQuestion[]>();

    var minimumDate = new Date();


    const [lateReasons, setLateReasons] = useState<VwLateEcldpnreason[]>([]);

    const [answerObject, setAnswerObject] = useState<EDPNAnswerObject | null>(null);

    useEffect(() => {
        GetCliniciansForDropdown();
        UpdateReasonsForDropdown();
        UpdateQuestions();
    }, []);

    useEffect(() => {
        if (clinicians) {
            var tempFilteredClinicians = clinicians.filter(x => x.therapistId !== globalContext.CoreAccount.therapistData?.therapistId);
            setFilteredClinicians(tempFilteredClinicians);
        }
    }, [clinicians]);

    useEffect(() => {
        if (props.clients) {
            setClients(props.clients);
        }

    }, [props.clients]);

    useEffect(() => {
        ValidateInformation();

    }, [dateOfService, selectedClinician, selectedCptCode, selectedLearner, selectedReason, isLateAbsentNote, selectedAbsentReason]);

    useEffect(() => {

        if (props.isActive && selectedCptCode) {
            ResetAnswerObject();
        }

    }, [props.isActive, selectedCptCode])

    function CreateAnswerObject(realUTCtime: Date): EDPNAnswerObject {

        const datePart = dateOfService ? new Date(dateOfService) : null;

        //create billingDate by combining date from `dateOfService` with time from `realUTCtime`
        const billingDate = datePart && realUTCtime
            ? new Date(
                Date.UTC(
                    datePart.getFullYear(),
                    datePart.getMonth(),
                    datePart.getDate(),
                    realUTCtime.getUTCHours(),
                    realUTCtime.getUTCMinutes(),
                    realUTCtime.getUTCSeconds(),
                    realUTCtime.getUTCMilliseconds()
                )
            )
            : null;

        var answerObject: EDPNAnswerObject = {
            answers: [],
            logId: null,
            startTime: dateOfService && !isLateAbsentNote ? new Date(dateOfService?.toLocaleString() + " +0000") : null,
            endTime: dateOfService && !isLateAbsentNote ? new Date(dateOfService?.toLocaleString() + " +0000") : null,
            createdDate: realUTCtime,
            approvedDate: null,
            clientId: Number(selectedLearner?.value),
            cptcode: selectedCptCode?.value ?? null,
            narrative: null,
            billingDate: billingDate,
            therapistId: globalContext.CoreAccount.therapistData?.therapistId ?? null,
            dpnstatusId: 2,
            active: true,
            harvested: false,
            client: null,
            dpnstatus: null,
            therapist: null,
            ecldpnanswers: null,
            placeOfServiceId: edpnContext.selectedServicePlace ? Number(edpnContext.selectedServicePlace.value) : null,
            centerId: edpnContext.selectedCenter ? edpnContext.selectedCenter.centerId : null,
            updatedOn: null,
            updatedBy: null,
            approvedById: null,
            podId: edpnContext.clients ? (edpnContext.clients.find(x => x.clientId === Number(selectedLearner?.value))?.podId ?? null) : null,
            clientName: null,
            comments: null,
            modeOfServiceId: null,
            isIamedicaid: null,
            isIlmedicaid: null,
            isInmedicaid: null,
            isMimedicaid: null,
            logSetId: null,
            timezone: null,
            showApproveButton: null,
            therapyScheduleId: null,
            therapySchedule: null,
            companyInsuranceId: null,
            absent: null,
            absentReasonId: null,
            absentReason: null,
            tardyReasonId: null,
            tardyReason: null,
            antecendant: null,
            bcbaname: null,
            injury: null,
            scheduleDuration: null,
            dpnactualDuration: null,
            duration: null,
            groupId: null,
            lateReasonId: null,
            source: null,
            pendingAuditReview: null,
        };

        //dynamically generate answers
        filteredFlatQuestions?.forEach(question => {
            answerObject.answers?.push(GenerateBlankEDPNAnswerFromEDPNQuestion(question));
        })

        return answerObject;
    }

    function GenerateBlankEDPNAnswerFromEDPNQuestion(question: EDPNQuestion) {

        var tempanswer: EDPNAnswer = {
            answerId: null,
            questionId: question.questionId,
            multiIndex: null,
            logId: null,
            textValue: null,
            numberValue: null,
            boolValue: null,
            choiceValue: null,
            log: null,
            question: null
        };

        switch (question.type) {
            case "abaname":
                tempanswer.textValue = "-1";
                break;
            case "abapresent":
                tempanswer.choiceValue = -1;
                break;
            case "bcbaname":
                tempanswer.textValue = "-1";
                break;
            case "bcbapresent":
                tempanswer.choiceValue = -1;
                break;
            case "bool_default_false":
                tempanswer.boolValue = false;
                break;
            case "bool_default_false_aba":
                tempanswer.boolValue = false;
                break;
            case "bool_default_false_abnormal_behaviors":
                tempanswer.boolValue = false;
                break;
            case "bool_default_false_bcba":
                tempanswer.boolValue = false;
                break;
            case "bool_default_false_injury":
                tempanswer.boolValue = false;
                break;
            case "bool_default_false_participate":
                tempanswer.boolValue = false;
                break;
            case "bool_default_false_people":
                tempanswer.boolValue = false;
                break;
            case "choice":
                tempanswer.choiceValue = -1;
                break;
            case "modality":
                tempanswer.choiceValue = -1;
                break;
            case "mode_of_service":
                tempanswer.choiceValue = -1;
                break;
            case "choice_absent_reasons":
                tempanswer.choiceValue = -1;
                break;
            case "longtext":
                tempanswer.textValue = "";
                break;
            case "multichoice":
                tempanswer.textValue = "";
                break;
            case "multichoicecreatable":
                tempanswer.textValue = "";
                break;
            case "multichoicecreatableadjustments":
                tempanswer.textValue = "";
                break;
            case "multichoicecreatableassessments":
                tempanswer.textValue = "";
                break;
            case "multichoicedirection":
                tempanswer.textValue = "";
                break;
            case "multichoiceimplement":
                tempanswer.textValue = "";
                break;
            case "multichoiceoptional":
                tempanswer.textValue = "";
                break;
            case "multirbt":
                tempanswer.textValue = "-1";
                break;
            case "multitech":
                tempanswer.textValue = "-1";
                break;
            case "multitext":
                tempanswer.textValue = "";
                break;
            case "multitextcaregiver":
                tempanswer.textValue = "";
                break;
            case "none":
                break;
            case "number":
                break;
            case "peoplename":
                tempanswer.textValue = "-1";
                break;
            case "peoplepresent":
                tempanswer.choiceValue = -1;
                break;
            case "rbt":
                tempanswer.textValue = "-1";
                break;
            case "text":
                tempanswer.textValue = "";
                break;
            case "text_abnormal_behaviors":
                tempanswer.textValue = "";
                break;
            case "text_injury":
                tempanswer.textValue = "";
                break;
            case "text_interview":
                tempanswer.textValue = "";
                break;
            case "text_participate":
                tempanswer.textValue = "";
                break;
            case "text_split":
                tempanswer.textValue = "";
                break;
            case "text_caregiver":
                tempanswer.textValue = "";
                break;
            default:
                break;
        }

        return tempanswer;
    }

    //FILTER CPT CODES
    useEffect(() => {
        if (edpnContext.CPTCodes && edpnContext.selectedCenter) {

            // filter CPTcodes by state
            var tempcodes: CPTCode[] = edpnContext.CPTCodes.filter(x => x.value != "H0032" && x.value != "G9012" && x.value != "97152" && x.value != "97156" && x.value != "99366" && x.value != "99368");

            //add michigan codes
            if ((edpnContext.selectedCenter && edpnContext.selectedCenter.state == "MI") || (edpnContext.selectedClient && edpnContext.selectedClient.isMimedicaid)) {
                edpnContext.CPTCodes.filter(x => x.value == "H0032" || x.value == "97152").forEach(x => tempcodes.push(x));
            }

            //add iowa codes (includes test center ID = 21)
            if ((edpnContext.selectedCenter && edpnContext.selectedCenter.state == "IA") || (edpnContext.selectedCenter && edpnContext.selectedCenter.centerId == 21) || (edpnContext.selectedClient && edpnContext.selectedClient.isIamedicaid)) {
                edpnContext.CPTCodes.filter(x => x.value == "G9012" || x.value == "97152").forEach(x => tempcodes.push(x));
            }

            //add 97156 for IOWA and EAST MOLINE ONLY for RBT, BCBA gets it always
            if (edpnContext.selectedCenter && (edpnContext.selectedCenter.state == "IA" || edpnContext.selectedCenter.centerId == 48 || globalContext.CheckRoles("BCBA"))) {
                edpnContext.CPTCodes.filter(x => x.value == "97156").forEach(x => tempcodes.push(x));
            }

            //add tricare codes for NE, NC, IA, IN, EAST MOLINE, (includes test center ID = 21)
            if (edpnContext.selectedCenter && (edpnContext.selectedCenter.state == "NE" || edpnContext.selectedCenter.state == "NC" || edpnContext.selectedCenter.state == "IA" || edpnContext.selectedCenter.state == "IN" || edpnContext.selectedCenter.centerId == 48 || edpnContext.selectedCenter.centerId == 21)) {
                edpnContext.CPTCodes.filter(x => x.value == "99366" || x.value == "99368").forEach(x => tempcodes.push(x));
            }

            // Filter CPT codes by effective date
            globalContext.GetToken().then((token: any) => {
                globalContext.getCurrentCenterTime(token, edpnContext?.selectedCenter?.centerId).then((billingDate: Date) => {

                    tempcodes = tempcodes.filter(x => {
                        const startDate = x.effectiveDateStart ? new Date(x.effectiveDateStart) : null;
                        const endDate = x.effectiveDateEnd ? new Date(x.effectiveDateEnd) : null;

                        return (
                            (!startDate || startDate <= billingDate || startDate.toDateString() === billingDate.toDateString()) &&
                            (!endDate || endDate >= billingDate || endDate.toDateString() === billingDate.toDateString())
                        );
                    });

                    //filter codes by permissions
                    if (globalContext.CheckRoles("ADMIN")) {
                        //SUPER ADMIN GETS ALL CODES
                        tempcodes = tempcodes;
                    }
                    else if (globalContext.CheckRoles("RBT")) {
                        //RBT
                        tempcodes = tempcodes.filter(x => x.rbtbillable);
                    }
                    else if (globalContext.CheckRoles("BCBA")) {
                        //BCBA
                        tempcodes = tempcodes.filter(x => x.bcbabillable);
                    }
                    else {
                        //not in either group, just default to RBT
                        tempcodes = tempcodes.filter(x => x.rbtbillable);
                    }

                    //sort
                    tempcodes = tempcodes.sort((a, b) => (a.sortOrder ?? Infinity) - (b.sortOrder ?? Infinity));


                    setFilteredCPTCodes(tempcodes);
                });
            });
        }

    }, [edpnContext.CPTCodes, edpnContext.selectedCenter]);


    function GetCliniciansForDropdown() {

        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            var options = {
                method: "GET",
                headers: headers
            };

            var url = apiConfig.apiEndpoint + "/Centers/GetAllClinicians";

            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setClinicians(result);
                    },
                    (error) => {
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Centers/GetAllClinicians" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        });
    }

    function UpdateReasonsForDropdown() {
        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            var options = {
                method: "GET",
                headers: headers
            };

            var url = apiConfig.apiEndpoint + "/EDPN/GetLateNoteReasons?isEDPN=true";

            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        setLateReasons(result);
                        //setLoading(false);
                    },
                    (error) => {
                        //setLoading(false);
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/EDPN/GetLateNoteReasons" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        });
    }

    function OnClinicianChange(input: SingleValue<ChoiceOption>) {

        if (clinicians) {

            var foundClinician = clinicians?.find(z => String(z.therapistId) === String(input?.value));
            var temp: ChoiceOption;

            if (foundClinician) {
                temp = ({ value: String(foundClinician.therapistId), label: foundClinician.employeeName })
                setSelectedClinician(temp);
            }
        }
    }

    function OnSelectedClientChange(input: SingleValue<ChoiceOption>) {

        if (clients) {

            var foundClinician = clients?.find(z => String(z.clientId) === String(input?.value));
            var temp: ChoiceOption;

            if (foundClinician) {
                temp = ({ value: String(foundClinician.clientId), label: foundClinician.fullName })
                setSelectedLearner(temp);
                setSelectedLearnerPodId(foundClinician.podId);
            }
        }
    }

    function OnSelectedReasonChange(input: SingleValue<ChoiceOption>) {

        if (lateReasons) {

            var foundReason = lateReasons?.find(z => String(z.reasonId) === String(input?.value));
            var temp: ChoiceOption;

            if (foundReason) {
                temp = ({ value: String(foundReason.reasonId), label: foundReason.reason })
                setSelectedReason(temp);
            }
        }
    }

    function ValidateInformation() {
        const tomorrow = new Date(); // Start with the current date
        tomorrow.setDate(tomorrow.getDate() + 1); // Move to tomorrow
        tomorrow.setHours(0, 0, 0, 0); // Set time to 12:00 AM (midnight)

        if (
            dateOfService &&
            minimumDate &&
            dateOfService >= minimumDate && dateOfService <= tomorrow &&
            selectedClinician &&
            (!isLateAbsentNote ? selectedCptCode : true) &&
            selectedLearner &&
            selectedReason &&
            (isLateAbsentNote ? selectedAbsentReason : true)
        ) {
            setConfirmButtonActive(true);
        } else {
            setConfirmButtonActive(false);
        }
    }

    function ResetAnswerObject() {

        console.log("reset answer object");

        setAnswerObject({
            answers: [],
            logId: null,
            startTime: null,
            endTime: null,
            createdDate: null,
            approvedDate: null,
            clientId: null,
            cptcode: null,
            narrative: null,
            billingDate: null,
            therapistId: null,
            dpnstatusId: null,
            active: true,
            harvested: false,
            client: null,
            dpnstatus: null,
            therapist: null,
            ecldpnanswers: null,
            placeOfServiceId: null,
            centerId: null,
            updatedOn: null,
            updatedBy: null,
            approvedById: null,
            podId: null,
            clientName: null,
            comments: null,
            modeOfServiceId: null,
            isIamedicaid: null,
            isIlmedicaid: null,
            isInmedicaid: null,
            isMimedicaid: null,
            logSetId: null,
            timezone: null,
            showApproveButton: null,
            absent: false,
            absentReasonId: null,
            absentReason: null,
            tardyReasonId: null,
            tardyReason: null,
            therapyScheduleId: null,
            therapySchedule: null,
            companyInsuranceId: null,
            antecendant: null,
            bcbaname: null,
            injury: null,
            scheduleDuration: null,
            dpnactualDuration: null,
            duration: null,
            groupId: null,
            lateReasonId: null,
            source: null,
            pendingAuditReview: null,
        })

    }

    function AddEDPNNote() {

        setIsSaving(true);
        setConfirmButtonActive(false);

        

        globalContext.GetToken().then((token: any) => {
            globalContext.GetRealUTCTime(token).then((realUtcTime: Date) => {

                var finalAnswerObject = CreateAnswerObject(realUtcTime);

                if (answerObject && finalAnswerObject) {
                    if (selectedCptCode) {
                        finalAnswerObject.cptcode = selectedCptCode.value;
                    }

                    if (selectedClinician) {
                        finalAnswerObject.therapistId = Number(selectedClinician.value);
                    }

                    if (!finalAnswerObject.createdDate) {
                        finalAnswerObject.createdDate = new Date(new Date().toLocaleString() + " +0000");
                    }

                    if (!finalAnswerObject.billingDate) {
                        finalAnswerObject.billingDate = new Date();
                    }

                    if (!finalAnswerObject.startTime && !isLateAbsentNote) {
                        finalAnswerObject.startTime = new Date(dateOfService?.toLocaleString() + " +0000");
                    }

                    if (!finalAnswerObject.endTime && !isLateAbsentNote) {
                        finalAnswerObject.endTime = new Date(dateOfService?.toLocaleString() + " +0000");
                    }

                    if (edpnContext.selectedServicePlace) {
                        finalAnswerObject.placeOfServiceId = 1;
                    }

                    if (edpnContext && edpnContext?.selectedCenter) {
                        finalAnswerObject.centerId = edpnContext?.selectedCenter.centerId;
                    }

                    if (selectedLearner) {
                        finalAnswerObject.clientId = Number(selectedLearner.value);
                    }

                    //this doesn't work because one is not selected
                    /*if (edpnContext.selectedClient && edpnContext.selectedClient.podId) {
                        finalAnswerObject.podId = edpnContext.selectedClient.podId;
                    }*/


                    finalAnswerObject.podId = selectedLearnerPodId;


                    // swap with late reason id

                    if (isLateAbsentNote && selectedAbsentReason) {
                        //set absent stuff
                        finalAnswerObject.absent = true;
                        finalAnswerObject.absentReasonId = selectedAbsentReason.id;

                        //set the answer to null just in case this is how the submit button is showing in the view page
                        finalAnswerObject.answers = [];
                        finalAnswerObject.cptcode = null;
                    }
                    if (selectedReason) {
                        finalAnswerObject.lateReasonId = Number(selectedReason.value);
                    }

                    if (isLateAbsentNote) {
                        finalAnswerObject.dpnstatusId = 4;
                    }
                    else {
                        finalAnswerObject.dpnstatusId = 2;
                    }


                    //source, default to DPN if app is not set, but this should never happen, and will fail in the backend
                    finalAnswerObject.source = selectedCptCode?.app ? selectedCptCode?.app : "DPN";

                }

                globalContext.GetToken().then((token: any) => {
                    var headers = new Headers();
                    var bearer = "Bearer " + token;
                    headers.append("Authorization", bearer);
                    headers.append("Content-type", "application/json;charset=UTF-8");

                    var options = {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify(finalAnswerObject),
                    };

                    const size = new TextEncoder().encode(JSON.stringify(finalAnswerObject)).length;
                    const kiloBytes = size / 1024;

                    console.log("finalanswerobject sent to api:", finalAnswerObject);

                    var url = apiConfig.apiEndpoint + "/EDPN/UpdateEDPN";

                    // Timeout setup
                    const controller = new AbortController();
                    const timeoutId = setTimeout(() => controller.abort(), 20000); // 20 seconds

                    fetch(url, { ...options, signal: controller.signal })
                        .then((res) => res.json())
                        .then(
                            (result: APIReturnObject) => {
                                clearTimeout(timeoutId);
                                console.log("api result:", result);
                                if (result.status === Status.SUCCESS) {
                                    if (result.message) {
                                        const newLogObject = JSON.parse(result.message);
                                        console.log("Autosaved:", newLogObject);

                                        globalContext.setToastMessage((isLateAbsentNote ? "Absent " : "Late ") + "Note Added");
                                        globalContext.setToastIcon("Success");
                                        globalContext.setToastActive(true);

                                        const oldLogObject = answerObject;

                                        if (oldLogObject && newLogObject && newLogObject.LogId) {
                                            oldLogObject.logId = newLogObject.LogId;
                                        }

                                        setAnswerObject(oldLogObject);
                                        setConfirmButtonActive(true);
                                    }
                                }
                                else if (result.status === Status.FAIL) {
                                    globalContext.setNotificationModalMessage("Cannot create " + (isLateAbsentNote ? "Absent " : "Late ") + "note. " + result.message);
                                    globalContext.setNotificationModalActive(true);
                                    setConfirmButtonActive(true);
                                }
                                else if (result.status === Status.ERROR) {
                                    globalContext.setErrorModalProps({ errorMessage: "Failed to create Late note. " + result.message, errorLocation: "/EDPN/UpdateEDPN" });
                                    globalContext.setErrorModalActive(true);
                                    setConfirmButtonActive(true);
                                }
                                setIsSaving(false);
                                CancelModal();
                            },
                            (error) => {
                                clearTimeout(timeoutId);
                                if (error.name === "AbortError") {
                                    console.log("Request timed out");
                                    globalContext.setToastMessage("Save Failed. Connection timed out.");
                                    globalContext.setToastIcon("Warning");
                                    globalContext.setToastActive(true);
                                }
                                else {
                                    globalContext.setErrorModalProps({
                                        errorMessage: error,
                                        errorLocation: "/EDPN/UpdateEDPN",
                                    });
                                    globalContext.setErrorModalActive(true);
                                }
                                setIsSaving(false);
                                CancelModal();
                            }
                        );
                });
            })
        })

        
    }

    function CancelModal() {
        ClearValues();
        props.setActive(false);
    }

    function ConfirmModal() {
        AddEDPNNote();
    }

    function ClearValues() {
        setSelectedClinician(null);
        setSelectedCptCode(null);
        setSelectedLearner(null);
        setSelectedReason(null);
        setIsLateAbsentNote(false);
        setSelectedAbsentReason(null);
        setDateOfService(null);
    }

    // Function to determine if a date should be disabled
    const normalizeDate = (date: any) => {
        const normalized = new Date(date);
        normalized.setHours(0, 0, 0, 0);
        return normalized;
    };

    //TODO use server time at the center instead of local pc time - greatest programmer alive is too rushed to fix this right now - 6/12/25
    const shouldDisableDate = (date: any) => {
        //const today = normalizeDate(new Date(2025, 0, 12)); // Example: Jan 5, 2025 (Sunday)
        const today = normalizeDate(new Date());
        const normalizedDate = normalizeDate(date);

        //const thisIsFalse = false; // this is because ecl does not work for me right now and I have to test 

        // Function to calculate the previous valid day, skipping weekends
        const getPreviousValidDay = (baseDate: Date, daysAgo: number): Date => {
            const validDate = new Date(baseDate);
            let daysCount = 0;

            while (daysCount < daysAgo) {
                validDate.setDate(validDate.getDate() - 1);
                const dayOfWeek = validDate.getDay();
                // Skip Saturday (6) and Sunday (0) if props.isEDPN is true
                if ((dayOfWeek !== 0 && dayOfWeek !== 6)) {
                    daysCount++;
                }
            }
            return normalizeDate(validDate);
        };

        const dayOfWeek = today.getDay();

        let todayIncluded, previousDay1, previousDay2, previousDay3, previousDay4, previousDay5;

        if (dayOfWeek === 6 || dayOfWeek === 0) {
            if (selectedCptCode && selectedCptCode.app && selectedCptCode.app == 'DPN') {
                // If today is Saturday or Sunday, adjust to Friday as "today"
                const adjustedToday = getPreviousValidDay(today, 1); // Set to Friday
                todayIncluded = adjustedToday; // Friday
                previousDay1 = getPreviousValidDay(adjustedToday, 1); // Thursday
                previousDay2 = getPreviousValidDay(adjustedToday, 2); // Wednesday
                previousDay3 = getPreviousValidDay(adjustedToday, 3); // Tuesday

                minimumDate = previousDay3;

                return !(
                    normalizedDate.getTime() === todayIncluded.getTime() ||
                    normalizedDate.getTime() === previousDay1.getTime() ||
                    normalizedDate.getTime() === previousDay2.getTime()
                );
            }
            else {
                //do not adjust todays date, just check if it is sat or sunday and go from there
                if (dayOfWeek === 6) {
                    // Not normal case.
                    todayIncluded = today;
                    previousDay1 = getPreviousValidDay(today, 1);
                    previousDay2 = getPreviousValidDay(today, 2);
                    previousDay3 = getPreviousValidDay(today, 3);

                    minimumDate = previousDay3;
                    return !(
                        normalizedDate.getTime() === todayIncluded.getTime() ||
                        normalizedDate.getTime() === previousDay1.getTime() ||
                        normalizedDate.getTime() === previousDay2.getTime() ||
                        normalizedDate.getTime() === previousDay3.getTime()
                    );
                }
                else {
                    // Not normal case. SUNNNNDAAAAYYYYY
                    todayIncluded = today;
                    previousDay1 = getPreviousValidDay(today, 1);
                    previousDay2 = getPreviousValidDay(today, 2);
                    previousDay3 = getPreviousValidDay(today, 3);

                    const sunday = normalizeDate(new Date(today));
                    sunday.setDate(today.getDate() - (today.getDay() - 0));

                    // have to do saturday after sunday because sunday is part of this week and sat is not.
                    const saturday = normalizeDate(new Date(today));
                    saturday.setDate(sunday.getDate() - 1);

                    minimumDate = previousDay3;
                    return !(
                        normalizedDate.getTime() === todayIncluded.getTime() ||
                        normalizedDate.getTime() === saturday.getTime() ||
                        normalizedDate.getTime() === previousDay1.getTime() ||
                        normalizedDate.getTime() === previousDay2.getTime() ||
                        normalizedDate.getTime() === previousDay3.getTime()
                    );
                }
            }
        } else {
            if (selectedCptCode && selectedCptCode.app && selectedCptCode.app == 'DPN') {
                // Normal case: calculate the previous three valid weekdays
                todayIncluded = today;
                previousDay1 = getPreviousValidDay(today, 1);
                previousDay2 = getPreviousValidDay(today, 2);
                previousDay3 = getPreviousValidDay(today, 3);

                minimumDate = previousDay3;

                return !(
                    /*normalizedDate.getTime() === todayIncluded.getTime() ||*/
                    normalizedDate.getTime() === previousDay1.getTime() ||
                    normalizedDate.getTime() === previousDay2.getTime() ||
                    normalizedDate.getTime() === previousDay3.getTime()
                );
            }
            else {
                // Normal case: calculate the previous three valid weekdays
                todayIncluded = today;
                previousDay1 = getPreviousValidDay(today, 1);
                previousDay2 = getPreviousValidDay(today, 2);
                previousDay3 = getPreviousValidDay(today, 3);

                const sunday = normalizeDate(new Date(today));
                sunday.setDate(today.getDate() - (today.getDay() - 0));

                // have to do saturday after sunday because sunday is part of this week and sat is not.
                const saturday = normalizeDate(new Date(today));
                saturday.setDate(sunday.getDate() - 1);

                if (today.getDay() === 5) {
                    minimumDate = previousDay3;

                    return !(
                        /*normalizedDate.getTime() === todayIncluded.getTime() ||*/
                        normalizedDate.getTime() === previousDay1.getTime() ||
                        normalizedDate.getTime() === previousDay2.getTime() ||
                        normalizedDate.getTime() === previousDay3.getTime()
                    );
                }
                else {
                    if (saturday < previousDay3) {
                        minimumDate = saturday;
                    }
                    else {
                        minimumDate = previousDay3;
                    }

                    return !(
                        /*normalizedDate.getTime() === todayIncluded.getTime() ||*/
                        normalizedDate.getTime() === previousDay1.getTime() ||
                        normalizedDate.getTime() === previousDay2.getTime() ||
                        normalizedDate.getTime() === previousDay3.getTime() ||
                        normalizedDate.getTime() === saturday.getTime() ||
                        normalizedDate.getTime() === sunday.getTime()
                    );
                }
            }

        }
    };




    function UpdateQuestions() {

        globalContext.GetToken().then((token: any) => {
            var headers = new Headers();
            var bearer = "Bearer " + token;
            headers.append("Authorization", bearer);
            var options = {
                method: "GET",
                headers: headers
            };

            var url = apiConfig.apiEndpoint + "/Admin/GetAllQuestions";

            fetch(url, options)
                .then(res => res.json())
                .then(
                    (result) => {
                        //console.log("raw questions:", result);
                        setQuestions(result);
                    },
                    (error) => {
                        globalContext.setErrorModalProps({ errorMessage: error, errorLocation: "/Admin/GetAllQuestions" });
                        globalContext.setErrorModalActive(true);
                    }
                )
        })
    }



    useEffect(() => {
        //console.log("questions:", questions);
        if (questions) {

            //reset tempflatquestions, then regenerate them.
            tempFlatQuestions = [];

            GenerateFlatQuestions(questions);

            setFlatQuestions(tempFlatQuestions);
        }

    }, [questions]);

    useEffect(() => {
        if (selectedCptCode && selectedCptCode.value) {
            //filter questions by effective dates
            globalContext.GetToken().then((token: any) => {
                globalContext.getCurrentCenterTime(token, edpnContext.selectedCenter?.centerId).then((centerTime: Date) => {
                    setFilteredFlatQuestions(flatQuestions.filter(question =>
                        String(question.cptcode) === String(selectedCptCode.value) &&
                        (!question.effectiveDateStart || new Date(question.effectiveDateStart) <= centerTime) &&
                        (!question.effectiveDateEnd || new Date(question.effectiveDateEnd) >= centerTime)
                    ));
                });
            });


        }
        else {
            setFilteredFlatQuestions([]);
        }
        
    }, [selectedCptCode]);

   
    function GenerateFlatQuestions(questions: EDPNQuestion[]) {
        tempFlatQuestions = tempFlatQuestions.concat(questions);

        questions.forEach((q) => {
            if (Array.isArray(q.children)) {
                GenerateFlatQuestions(q.children);
            }
        })

    }

    return (
        <div className={"z-[50] fixed inset-0 " + (props.isActive ? "normal" : "hidden")} aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity z-[40]"></div>

            <div className="fixed inset-0 z-[50] overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all z-[60]">
                        <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                            <div className="">
                                <div className="mt-3 sm:mt-0 p-10">

                                    <div className="place-items-center">
                                        <h2 className="text-2xl text-lacblue font-bold">Add Late {isLateAbsentNote ? "Absent" : ""} Session Note</h2>
                                        <h3 className="italic text-blue mb-5">(After Date of Service)</h3>
                                    </div>


                                    <div className="w-full">
                                        <label className="text-lg leading-6 text-left block" id="modal-title">
                                            <span className="font-medium">Date of Service</span>
                                            <span className="italic ">(Must be within 72 hours of today)</span>
                                        </label>
                                        <DatePicker
                                            value={dateOfService}
                                            shouldDisableDate={shouldDisableDate}
                                            disabled={false}
                                            disableFuture={false}
                                            onChange={(newValue) => setDateOfService(newValue)}
                                            className="w-full"
                                            renderInput={(params) => <TextField size="small" className="w-full" {...params} />}
                                        />
                                    </div>

                                    <div>
                                        <label className="leading-6 block text-left" id="modal-title">
                                            <span className="font-medium text-lg">Rendering Clinician</span>
                                            <span className="italic text-md">(Who provided the service to the Patient {selectedCptCode && selectedCptCode.app && selectedCptCode.app == 'DPN' ? "" : ", Cannot select yourself"})</span>
                                        </label>
                                        <Select
                                            className="w-full"
                                            options={filteredClinicians && filteredClinicians.length > 0 ? filteredClinicians.map((clinician) => ({ value: String(clinician.therapistId), label: clinician.employeeName })) : undefined}
                                            onChange={OnClinicianChange}
                                            value={selectedClinician}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 1000 })
                                            }}
                                        />
                                    </div>

                                    <div className={selectedCptCode && selectedCptCode.app && selectedCptCode.app == 'DPN' ? "" : "hidden"}>
                                        <label className="text-lg block font-bold" htmlFor="centers">
                                            Absent Note:
                                        </label>

                                        <label className="relative inline-flex items-center cursor-pointer">
                                            <input
                                                type="checkbox"
                                                onChange={e => setIsLateAbsentNote(e.target.checked)}
                                                checked={isLateAbsentNote}
                                                className="sr-only peer"
                                            />
                                            <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>
                                        </label>
                                    </div>

                                    <div className={isLateAbsentNote ? "hidden" : ""}>
                                        <label className="text-lg leading-6 font-medium text-left">CPT Code</label>
                                        <Select
                                            className="w-full"
                                            options={FilteredCPTCodes ? FilteredCPTCodes : undefined}
                                            onChange={setSelectedCptCode}
                                            value={selectedCptCode}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 1000 })
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label className="text-lg leading-6 font-medium text-left">Patient Name</label>
                                        <Select
                                            className="w-full"
                                            options={clients && clients.length > 0 ? clients.map((client) => ({ value: String(client.clientId), label: String(client.fullName) })) : undefined}
                                            onChange={OnSelectedClientChange}
                                            value={selectedLearner}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 1000 })
                                            }}
                                        />
                                    </div>

                                    <div className={isLateAbsentNote ? "" : "hidden"}>
                                        <label className="text-lg block font-medium" htmlFor="centers">
                                            Absent Reason:
                                        </label>
                                        <Select
                                            className="w-full"
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 1000 })
                                            }}
                                            isSearchable={false}
                                            options={edpnContext.absentReasons ? edpnContext.absentReasons?.filter(x => x.absent == true) : undefined}
                                            onChange={setSelectedAbsentReason}
                                            value={selectedAbsentReason}
                                        />
                                    </div>


                                    <div>
                                        <label className="text-lg leading-6 text-left">
                                            <span className="font-medium">Reason</span>
                                            <span className="italic">(Reason for note submission after date of service)</span>
                                        </label>
                                        <Select
                                            className="w-full"
                                            options={lateReasons && lateReasons.length > 0 ? lateReasons.map((reason) => ({ value: String(reason.reasonId), label: String(reason.reason) })) : undefined}
                                            onChange={OnSelectedReasonChange}
                                            value={selectedReason}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            styles={{
                                                menuPortal: (base) => ({ ...base, zIndex: 1000 })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex bg-gray-50 px-4 py-3 sm:px-6 mx-auto">
                            <div className="flex justify-center mx-auto">
                                <button onClick={CancelModal} className="bg-rose w-[7rem] h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-rose-600">
                                    <span className="drop-shadow">Cancel</span>
                                </button>
                                <button onClick={ConfirmModal} disabled={!confirmButtonActive} className={"bg-lacgreen ml-5 w-[7rem] h-[2rem] rounded font-bold text-lg text-white transition duration-250 ease-in-out hover:bg-lacgreen-600 " + (confirmButtonActive ? 'hover:bg-lacgreen-600' : 'opacity-50 cursor-not-allowed')}>
                                    {isSaving ? <FontAwesomeIcon className="fill-current text-white w-5 h-5 animate-spin m-auto" icon={solid('spinner')} /> : <span className="drop-shadow">Confirm</span>}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}